import React from 'react';

const ShipperTableComponentLoadable = React.lazy(() => import('./Shipper/ShipperTableComponent'));
const ConsigneeTableComponentLoadable = React.lazy(() => import('./Consignee/ConsigneeTableComponent'));

export {
    ShipperTableComponentLoadable,
    ConsigneeTableComponentLoadable
};

